export enum InscriptionFlowFormType {
  NoAccount = 1,
  Cps = 2,
  Cpx = 3,
  Morale = 4
}
